<template>
  <div>
    <div class="row col-12 q-mb-md container-adiciona">
      <div
        :class="{
          'opacity-50 cursor-not-allowed': !podeAdicionarResponsavel,
        }"
        style="pointer-events: auto"
      >
        <AdicionarResponsavel
          :ptId="pt.ptId"
          :unidade="pt.unidadeId"
          :disabled="!podeAdicionarResponsavel"
          @closing="$emit('atualizar')"
        />
      </div>
      <q-tooltip v-if="!podeAdicionarResponsavel" class="bg-negative">
        Você não tem permissão para Adicionar Responsáveis
      </q-tooltip>
    </div>
    <q-table
      grid
      :columns="columns"
      :rows="pt.responsaveis"
      row-key="uuid"
      hide-pagination
      dense
      :no-data-label="pt.responsaveis ? '' : 'Nenhum Responsável Adicionado'"
    >
      <template v-slot:item="props">
        <div style="width: 203px" class="mobile">
          <div v-if="props.row.assinaturas">
            <q-img
              v-if="props.row.assinaturas[0].assinaturaTipo == 'manual'"
              :src="props.row.assinaturas[0].assinatura"
              class="row border-img"
              spinner-color="white"
              height="185px"
              width="185px"
              fit="contain"
              no-native-menu
              :style="{
                display: props.row.ocultarAssinatura ? 'none' : 'block',
              }"
            >
              <q-btn
                :disable="
                  usuarioPodeEditar
                    ? pt.status != 'aguardando_assinaturas'
                    : pt.status != 'aguardando_assinaturas' ||
                      usuario != props.row.matricula
                "
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; left: 1px"
                text-color="dark"
                flat
                round
                size="md"
                icon="history_edu"
                @click="assinaturaResponsavel(ptId, props.row.responsavelId)"
              />
              <q-btn
                v-if="props.row.assinaturas"
                color="white"
                class="absolute all-pointer-events cursor"
                style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                text-color="primary"
                flat
                round
                size="sm"
                :icon="
                  props.row.ocultarAssinatura ? 'visibility' : 'visibility_off'
                "
                @click="toggleAssinaturaView(props.row)"
              >
                <q-tooltip class="bg-primary">
                  {{
                    props.row.ocultarAssinatura
                      ? "Mostrar Assinatura"
                      : "Ocultar Assinatura"
                  }}
                </q-tooltip>
              </q-btn>
              <q-btn
                :disable="!podeRemoverResponsavel(props.row)"
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; right: 1px"
                text-color="red"
                flat
                round
                size="md"
                icon="delete"
                @click="removerResponsavel(props.row.responsavelId)"
              >
                <q-tooltip
                  v-if="!podeRemoverResponsavel(props.row)"
                  class="bg-negative"
                >
                  Você não tem permissão para Remover
                </q-tooltip>
              </q-btn>
            </q-img>

            <q-img
              v-if="
                props.row.assinaturas[0].assinaturaTipo == 'manual' &&
                props.row.ocultarAssinatura
              "
              class="border-img container"
              no-native-menu
            >
              <span class="text-brand-5 text-weight-bold teste2"
                >Assinatura Oculta</span
              >
              <q-btn
                :disable="
                  usuarioPodeEditar
                    ? pt.status != 'aguardando_assinaturas'
                    : pt.status != 'aguardando_assinaturas' ||
                      usuario != props.row.matricula
                "
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; left: 1px"
                text-color="dark"
                flat
                round
                size="md"
                icon="history_edu"
                @click="assinaturaResponsavel(ptId, props.row.responsavelId)"
              />
              <q-btn
                color="white"
                class="absolute all-pointer-events cursor"
                style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                text-color="primary"
                flat
                round
                size="sm"
                icon="visibility"
                @click="toggleAssinaturaView(props.row)"
              >
                <q-tooltip class="bg-primary">Mostrar Assinatura</q-tooltip>
              </q-btn>
              <q-btn
                :disable="!podeRemoverResponsavel(props.row)"
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; right: 1px"
                text-color="red"
                flat
                round
                size="md"
                icon="delete"
                @click="removerResponsavel(props.row.responsavelId)"
              >
                <q-tooltip
                  v-if="!podeRemoverResponsavel(props.row)"
                  class="bg-negative"
                >
                  Você não tem permissão para Remover
                </q-tooltip>
              </q-btn>
            </q-img>

            <q-img
              v-if="
                ['biometrica', 'facial'].includes(
                  props.row.assinaturas[0].assinaturaTipo
                ) &&
                props.row.mostrandoAssinatura &&
                props.row.assinaturaImagem
              "
              :src="props.row.assinaturaImagem"
              class="row border-img"
              spinner-color="white"
              height="185px"
              width="185px"
              fit="contain"
              no-native-menu
            >
              <q-btn
                :disable="
                  usuarioPodeEditar
                    ? pt.status != 'aguardando_assinaturas'
                    : pt.status != 'aguardando_assinaturas' ||
                      usuario != props.row.matricula
                "
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; left: 1px"
                text-color="dark"
                flat
                round
                size="md"
                icon="history_edu"
                @click="assinaturaResponsavel(ptId, props.row.responsavelId)"
              />
              <q-btn
                color="white"
                class="absolute all-pointer-events cursor"
                style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                text-color="primary"
                flat
                round
                size="sm"
                icon="visibility_off"
                @click="toggleAssinaturaView(props.row)"
              >
                <q-tooltip class="bg-primary">Ocultar Assinatura</q-tooltip>
              </q-btn>
              <q-btn
                :disable="!podeRemoverResponsavel(props.row)"
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; right: 1px"
                text-color="red"
                flat
                round
                size="md"
                icon="delete"
                @click="removerResponsavel(props.row.responsavelId)"
              >
                <q-tooltip
                  v-if="!podeRemoverResponsavel(props.row)"
                  class="bg-negative"
                >
                  Você não tem permissão para Remover
                </q-tooltip>
              </q-btn>
            </q-img>

            <q-img
              v-if="props.row.assinaturas[0].assinaturaTipo == 'eletronica'"
              class="border-img container"
              no-native-menu
            >
              <span class="text-brand-5 text-weight-bold teste2"
                >Assinatura Eletrônica
              </span>
              <q-btn
                :disable="
                  usuarioPodeEditar
                    ? pt.status != 'aguardando_assinaturas'
                    : pt.status != 'aguardando_assinaturas' ||
                      usuario != props.row.matricula
                "
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; left: 1px"
                text-color="dark"
                round
                flat
                size="md"
                icon="history_edu"
                @click="assinaturaResponsavel(ptId, props.row.responsavelId)"
              />
              <q-btn
                :disable="!podeRemoverResponsavel(props.row)"
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; right: 1px"
                text-color="red"
                round
                flat
                size="md"
                icon="delete"
                @click="removerResponsavel(props.row.responsavelId)"
              >
                <q-tooltip
                  v-if="!podeRemoverResponsavel(props.row)"
                  class="bg-negative"
                >
                  Você não tem permissão para Remover
                </q-tooltip>
              </q-btn>
            </q-img>

            <q-img
              v-else-if="
                ['biometrica', 'pin', 'token', 'facial', 'cracha'].includes(
                  props.row.assinaturas[0].assinaturaTipo
                ) &&
                (!props.row.mostrandoAssinatura ||
                  props.row.carregandoAssinatura)
              "
              class="border-img container"
              no-native-menu
            >
              <div
                v-if="props.row.carregandoAssinatura"
                class="loading-overlay"
              >
                <q-spinner color="primary" size="2em" />
                <span class="text-brand-5 text-weight-bold loading-text"
                  >Carregando...</span
                >
              </div>
              <span v-else class="text-brand-5 text-weight-bold teste2">
                {{
                  props.row.assinaturas[0].assinaturaTipo === "cracha"
                    ? "Autenticado por Crachá"
                    : props.row.assinaturas[0].assinaturaTipo === "facial"
                    ? "Biometria Facial"
                    : props.row.assinaturas[0].assinaturaTipo === "biometrica"
                    ? "Biometria Digital"
                    : props.row.assinaturas[0].assinaturaTipo === "pin"
                    ? "Autenticado por PIN"
                    : props.row.assinaturas[0].assinaturaTipo === "token"
                    ? "Autenticado por Token"
                    : "Assinado Eletrônicamente"
                }}
              </span>
              <q-btn
                :disable="
                  usuarioPodeEditar
                    ? pt.status != 'aguardando_assinaturas'
                    : pt.status != 'aguardando_assinaturas' ||
                      usuario != props.row.matricula
                "
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; left: 1px"
                text-color="dark"
                round
                flat
                size="md"
                icon="history_edu"
                @click="assinaturaResponsavel(ptId, props.row.responsavelId)"
              />
              <q-btn
                v-if="props.row.assinaturas"
                color="white"
                class="absolute all-pointer-events cursor"
                style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                text-color="primary"
                flat
                round
                size="sm"
                icon="visibility"
                :loading="props.row.carregandoAssinatura"
                @click="toggleAssinaturaView(props.row)"
              >
                <q-tooltip class="bg-primary">Visualizar Assinatura</q-tooltip>
              </q-btn>
              <q-btn
                :disable="!podeRemoverResponsavel(props.row)"
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; right: 1px"
                text-color="red"
                round
                flat
                size="md"
                icon="delete"
                @click="removerResponsavel(props.row.responsavelId)"
              >
                <q-tooltip
                  v-if="!podeRemoverResponsavel(props.row)"
                  class="bg-negative"
                >
                  Você não tem permissão para Remover
                </q-tooltip>
              </q-btn>
            </q-img>
            <div
              class="row col-12 q-mt-sm items-center"
              style="background: #e8ffec; width: 90%"
            >
              <span class="elipse q-mr-sm bg-positive"></span>
              <span class="text-weight-bold text-brand-5 texto-assinatura">
                Assinatura Coletada</span
              >
            </div>
          </div>

          <div v-else>
            <q-img class="border-img container" no-native-menu>
              <span
                v-if="props.row.nome && props.row.matricula"
                class="text-brand-5 text-weight-bold teste"
                style="font-size: 18px"
                >Sem Assinatura</span
              >
              <span
                v-else
                class="text-brand-5 text-weight-bold teste"
                style="font-size: 16px; color: #f57c00"
                >Aguardando<br />Definição</span
              >
              <q-btn
                v-if="props.row.nome && props.row.matricula"
                :disable="
                  usuarioPodeEditar
                    ? pt.status != 'aguardando_assinaturas'
                    : pt.status != 'aguardando_assinaturas' ||
                      usuario != props.row.matricula
                "
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; left: 1px"
                text-color="dark"
                round
                flat
                size="md"
                icon="history_edu"
                @click="assinaturaResponsavel(ptId, props.row.responsavelId)"
              />
              <q-btn
                :disable="!podeRemoverResponsavel(props.row)"
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; right: 1px"
                text-color="red"
                round
                flat
                size="md"
                icon="delete"
                @click="removerResponsavel(props.row.responsavelId)"
              >
                <q-tooltip
                  v-if="!podeRemoverResponsavel(props.row)"
                  class="bg-negative"
                >
                  Você não tem permissão para Remover
                </q-tooltip>
              </q-btn>
            </q-img>

            <div
              v-if="!props.row.nome || !props.row.matricula"
              class="row col-12 q-mt-sm items-center"
              style="background: #fff3cd; width: 90%"
            >
              <span class="elipse q-mr-sm bg-warning"></span>
              <span class="text-weight-bold text-warning texto-assinatura">
                Aguardando Definição</span
              >
            </div>
            <div
              v-else
              class="row col-12 q-mt-sm items-center"
              style="background: #ffe9e9; width: 90%"
            >
              <span class="elipse q-mr-sm bg-red"></span>
              <span class="text-weight-bold text-red texto-assinatura">
                Assinatura NÃO Coletada</span
              >
            </div>
          </div>

          <q-card-section
            style="width: 200px; margin-top: 5px; padding: 0"
            class="text-weight-regular text-body2"
          >
            <div class="column text-brand-5 text-weight-regular">
              <span class="q-mb-sm" v-if="props.row.nome">{{
                props.row.nome
              }}</span>
              <q-btn
                v-else
                :disable="!podeEditarResponsavel(props.row)"
                flat
                no-caps
                dense
                color="orange"
                class="text-left justify-start"
                style="padding: 4px 8px; font-size: 14px; max-width: 200px"
                @click="editarResponsavel(props.row)"
              >
                <span class="q-mr-xs">Definir Responsável</span>
                <q-icon name="edit" size="16px" />
              </q-btn>

              <span class="q-mb-sm text-brand-5 text-weight-bold">
                <div class="text-brand-5 text-weight-regular">
                  <div class="texto text-brand-5 text-weight-bold">
                    Matricula:
                  </div>
                  {{ props.row.matricula || "Não atribuída" }}
                </div>
              </span>

              <span class="q-mb-sm text-brand-5 text-weight-bold">
                <div class="text-weight-regular">
                  <div class="texto text-brand-5 text-weight-bold">
                    Empresa:
                  </div>
                  {{
                    props.row.tipo == "emissor"
                      ? pt.empresa
                      : props.row.empresa || "Não definida"
                  }}
                </div>
              </span>

              <span class="q-mb-sm text-brand-5 text-weight-bold">
                <div class="text-weight-regular">
                  <div class="texto text-brand-5 text-weight-bold">Tipo:</div>
                  {{ props.row.tipo }}
                </div>
              </span>

              <span class="text-brand-5 text-weight-bold">
                <div class="text-weight-regular">
                  <div class="texto text-brand-5 text-weight-bold">
                    Terceirizado:
                  </div>
                  {{ props.row.terceirizado ? "Sim" : "Não" }}
                </div>
              </span>
            </div>
          </q-card-section>
        </div>
        <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4 mobileGrid">
          <div class="row card q-mb-md justify-around">
            <div class="col-7 q-mr-sm q-mt-sm">
              <q-card-section class="row text-brand-5 text-grid-table">
                <div
                  v-if="!props.row.nome || !props.row.matricula"
                  class="row col-12"
                  style="background: #fff3cd; width: 90%"
                >
                  <span class="elipse q-mr-sm bg-warning"></span>
                  <span class="text-weight-bold text-warning texto-assinatura">
                    Aguardando Definição</span
                  >
                </div>
                <div
                  class="row col-12"
                  style="background: #e8ffec; width: 90%"
                  v-else-if="props.row.assinaturas"
                >
                  <span class="elipse q-mr-sm bg-positive"></span>
                  <span class="text-weight-bold text-brand-5 texto-assinatura">
                    Assinatura Coletada</span
                  >
                </div>
                <div
                  class="row col-12"
                  style="background: #ffe9e9; width: 90%"
                  v-else
                >
                  <span class="elipse q-mr-sm bg-red"></span>
                  <span class="text-weight-bold text-red texto-assinatura">
                    Assinatura NÃO Coletada</span
                  >
                </div>
                <div class="col-12">
                  <span v-if="props.row.nome">{{ props.row.nome }}</span>
                  <q-btn
                    v-else
                    :disable="!podeEditarResponsavel(props.row)"
                    flat
                    no-caps
                    dense
                    color="orange"
                    class="text-left justify-start"
                    style="padding: 2px 4px; font-size: 11px; max-width: 180px"
                    @click="editarResponsavel(props.row)"
                  >
                    <span class="q-mr-xs">Definir Responsável</span>
                    <q-icon name="edit" size="14px" />
                  </q-btn>
                </div>
                <div class="col-12">
                  <span
                    ><strong>Matricula:</strong>
                    {{ props.row.matricula || "Não atribuída" }}</span
                  >
                </div>
                <div class="col-12">
                  <span><strong>Tipo:</strong> {{ props.row.tipo }}</span>
                </div>
                <div class="col-12">
                  <span
                    ><strong>Terceiro:</strong>
                    {{ props.row.terceirizado ? "Sim" : "Não" }}</span
                  >
                </div>
                <div class="col-12">
                  <span
                    ><strong>Empresa:</strong>
                    {{
                      props.row.tipo == "emissor"
                        ? pt.empresa
                        : props.row.empresa || "Não definida"
                    }}</span
                  >
                </div>
              </q-card-section>
            </div>
            <div
              class="col q-ml-md justify-center q-mt-md text-brand-5 text-weight-bold text-grid-table"
            >
              <div class="q-ml-lg">Assinatura</div>
              <div
                style="width: 110px; height: 70px"
                class="row items-center justify-center"
              >
                <q-img
                  v-if="
                    props.row.assinaturas &&
                    props.row.assinaturas[0].assinaturaTipo == 'manual'
                  "
                  :src="
                    props.row.assinaturas[0]
                      ? props.row.assinaturas[0].assinatura
                      : ''
                  "
                  spinner-color="white"
                />
                <span
                  style="font-size: 10px"
                  v-if="
                    props.row.assinaturas &&
                    props.row.assinaturas[0].assinaturaTipo == 'eletronica'
                  "
                  >Assinatura Eletrônica</span
                >
                <span
                  style="font-size: 10px"
                  v-else-if="
                    props.row.assinaturas &&
                    ['biometrica', 'pin', 'token', 'facial', 'cracha'].includes(
                      props.row.assinaturas[0].assinaturaTipo
                    )
                  "
                >
                  {{
                    props.row.assinaturas[0].assinaturaTipo === "cracha"
                      ? "Autenticado por Crachá"
                      : props.row.assinaturas[0].assinaturaTipo === "facial"
                      ? "Biometria Facial"
                      : props.row.assinaturas[0].assinaturaTipo === "biometrica"
                      ? "Biometria Digital"
                      : props.row.assinaturas[0].assinaturaTipo === "pin"
                      ? "Autenticado por PIN"
                      : props.row.assinaturas[0].assinaturaTipo === "token"
                      ? "Autenticado por Token"
                      : "Assinatura Eletrônica"
                  }}
                </span>
                <span
                  v-else-if="!props.row.nome || !props.row.matricula"
                  style="font-size: 10px; text-align: center; color: #f57c00"
                  >Aguardando<br />Definição</span
                >
              </div>
            </div>
            <div class="row col-12">
              <div class="column col-4">
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'aguardando_assinaturas'
                      : pt.status != 'aguardando_assinaturas' ||
                        usuario != props.row.matricula
                  "
                  class="btn-grid"
                  label="Assinatura"
                  icon="history_edu"
                  stack
                  style="background: #393939; color: white"
                  no-caps
                  @click="assinaturaResponsavel(ptId, props.row.responsavelId)"
                />
              </div>
              <div class="column col-4" v-if="props.row.assinaturas">
                <q-btn
                  class="btn-grid"
                  :label="
                    props.row.assinaturas[0].assinaturaTipo === 'manual'
                      ? props.row.ocultarAssinatura
                        ? 'Mostrar'
                        : 'Ocultar'
                      : props.row.mostrandoAssinatura
                      ? 'Ocultar'
                      : 'Ver'
                  "
                  icon="visibility"
                  stack
                  style="background: #1976d2; color: white"
                  no-caps
                  @click="toggleAssinaturaView(props.row)"
                />
              </div>
              <div class="column col-4">
                <q-btn
                  :disable="!podeRemoverResponsavel(props.row)"
                  class="btn-grid"
                  label="Deletar"
                  icon="delete"
                  stack
                  style="background: #cf1515; color: white"
                  no-caps
                  @click="removerResponsavel(props.row.responsavelId)"
                >
                  <q-tooltip
                    v-if="!podeRemoverResponsavel(props.row)"
                    class="bg-negative"
                  >
                    Você não tem permissão para Remover
                  </q-tooltip>
                </q-btn>
              </div>
            </div>
          </div>
        </div>
      </template>
    </q-table>

    <q-dialog v-model="showEditDialog" persistent>
      <q-card style="width: 800px; max-width: 95vw">
        <q-card-section>
          <div class="text-h6">Editar Responsável</div>
          <div class="text-subtitle2 text-weight-regular">
            {{ editingResponsavel?.tipo }}
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none modal-content-wrapper">
          <div v-if="editingResponsavel" class="modal-form-custom">
            <q-form class="row q-gutter-md" ref="modalForm">
              <div
                v-if="editingResponsavel.tipo !== 'responsavel_area'"
                class="col-12"
              >
                <q-checkbox
                  label="Terceirizado"
                  v-model="editingResponsavel.terceirizado"
                  @update:model-value="onTercerizadoChange"
                />
              </div>

              <div
                v-if="
                  !editingResponsavel.terceirizado ||
                  editingResponsavel.tipo === 'responsavel_area'
                "
                class="col-12"
              >
                <div class="q-mb-sm q-mt-sm text-weight-bold">Responsável</div>
                <select-component
                  :unidade="pt.unidadeId"
                  @selectValue="onFuncionarioSelected"
                  :label="'Responsável'"
                />
              </div>

              <template
                v-if="
                  editingResponsavel.terceirizado &&
                  editingResponsavel.tipo !== 'responsavel_area'
                "
              >
                <div class="col-5">
                  <div class="q-mb-sm text-weight-bold">Nome Empresa</div>
                  <select-component-parceiros
                    @selectValue="onParceiroSelected"
                    :label="'Nome Empresa'"
                    :unidadeId="pt.unidadeId"
                  />
                </div>
                <div class="col-5" v-if="parceiroSelecionado">
                  <div class="q-mb-sm text-weight-bold">Nome Parceiro</div>
                  <select-component-terceiros
                    @selectValue="onTerceiroSelected"
                    :unidade="pt.unidadeId"
                    :parceiro="parceiroSelecionado"
                    :label="'Nome Parceiro'"
                  />
                </div>
              </template>
            </q-form>
          </div>
        </q-card-section>

        <q-card-actions class="justify-between">
          <q-btn flat label="Cancelar" color="primary" @click="fecharEdicao" />
          <q-btn
            label="Confirmar"
            no-caps
            color="positive"
            icon="check_circle_outline"
            @click="confirmarEdicao"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { ref, computed, inject } from "@vue/runtime-core";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import AdicionarResponsavel from "./AdicionarResponsavel.vue";
import SelectComponent from "./SelectComponent.vue";
import SelectComponentParceiros from "./SelectComponentParceiros.vue";
import SelectComponentTerceiros from "./SelectComponentTerceiros.vue";

const columns = [
  {
    name: "nome",
    align: "left",
    label: "Nome",
    field: "nome",
    sortable: true,
  },
  {
    name: "matricula",
    align: "left",
    label: "Matricula",
    field: "matricula",
    sortable: true,
  },
  {
    name: "empresa",
    align: "left",
    label: "Empresa",
    field: "empresa",
    sortable: false,
  },
  {
    name: "tipo",
    label: "Tipo",
    align: "left",
    field: "tipo",
    sortable: false,
  },
  {
    name: "terceirizado",
    label: "terceirizado",
    align: "left",
    field: "terceirizado",
    sortable: false,
    format: (val) => {
      return val ? "sim" : "não";
    },
  },
  {
    name: "remover",
    label: "Remover",
    align: "center",
    field: "responsavelId",
    sortable: false,
  },
  {
    name: "assinaturas",
    label: "Assinaturas",
    align: "center",
    field: "responsavelId",
    sortable: false,
  },
];

export default {
  props: [
    "pt",
    "usuarioPodeEditar",
    "usuarioPodeAdicionarUser",
    "usuarioPodeRemoverUser",
  ],
  emits: ["responsaveisAtualizados", "atualizar"],
  components: {
    AdicionarResponsavel,
    SelectComponent,
    SelectComponentParceiros,
    SelectComponentTerceiros,
  },
  setup(props, { emit }) {
    const router = useRouter();
    const store = useStore();
    const quasar = useQuasar();
    const route = useRoute();
    const keycloak = inject("keycloak");
    let dados = ref([]);
    let url = ref([]);
    const ptId = route.params.ptId;
    const usuario = store.getters["autenticacao/usuarioLogado"].id;
    const editingResponsavel = ref(null);
    const showEditDialog = ref(false);
    const parceiroSelecionado = ref(null);
    const modalForm = ref(null);

    const dadosTemporarios = ref({
      nome: "",
      matricula: "",
      empresa: "",
      cargo: null,
    });

    const onTercerizadoChange = () => {
      dadosTemporarios.value = {
        nome: "",
        matricula: "",
        empresa: "",
        cargo: null,
      };
      parceiroSelecionado.value = null;
    };

    const onFuncionarioSelected = (value, funcionarioData) => {
      if (!value) return;

      let data = value.split("-");
      dadosTemporarios.value.matricula = data[1]?.trim() || "";
      dadosTemporarios.value.nome = data[0]?.trim() || "";
      dadosTemporarios.value.cargo = funcionarioData?.cargo || null;
      dadosTemporarios.value.empresa = keycloak.realm;
    };

    const onParceiroSelected = (value) => {
      parceiroSelecionado.value = value;
      dadosTemporarios.value.empresa = value.split(" - ")[2] || "";
    };

    const onTerceiroSelected = (value) => {
      dadosTemporarios.value.nome = value.split("-")[0]?.trim() || "";
      dadosTemporarios.value.matricula = value.split("-")[1]?.trim() || "";
    };

    const confirmarEdicao = async () => {
      try {
        if (!dadosTemporarios.value.nome || !dadosTemporarios.value.matricula) {
          quasar.notify({
            message: "Nome e matrícula são obrigatórios",
            color: "negative",
          });
          return;
        }

        let tipoId =
          editingResponsavel.value.tipoReponsavelId ||
          editingResponsavel.value.tipoResponsavelId ||
          editingResponsavel.value.tipoId ||
          editingResponsavel.value.responsavelTipoId ||
          editingResponsavel.value.tipo_responsavel_id;

        if (!tipoId) {
          try {
            const tiposResponse = await store.dispatch(
              "pdt/listarTiposResponsaveis",
              {
                unidadeId: props.pt.unidadeId,
              }
            );

            const tiposResponsaveis =
              tiposResponse.data?.resultado?.dados || [];
            const tipoEncontrado = tiposResponsaveis.find(
              (tipo) => tipo.tipo === editingResponsavel.value.tipo
            );

            if (tipoEncontrado) {
              tipoId = tipoEncontrado.tipoReponsavelId;
            }
          } catch (apiError) {
            console.error("Erro ao buscar tipos de responsáveis:", apiError);
          }
        }

        if (!tipoId) {
          console.error(
            "Nenhum tipoId encontrado. Campos disponíveis:",
            editingResponsavel.value
          );
          quasar.notify({
            message: "Erro: Tipo de responsável não encontrado",
            color: "negative",
          });
          return;
        }

        let novoResponsavelId = null;

        try {
          const novoResponsavel = await store.dispatch(
            "pdt/adicionarResponsavelPt",
            {
              ptId: props.pt.ptId,
              matricula: dadosTemporarios.value.matricula,
              nome: dadosTemporarios.value.nome,
              empresa: dadosTemporarios.value.empresa,
              tipo: editingResponsavel.value.tipo,
              terceirizado: editingResponsavel.value.terceirizado,
              tipoId: tipoId,
              cargo: dadosTemporarios.value.cargo,
            }
          );

          novoResponsavelId = novoResponsavel.data?.resultado?.id;

          await store.dispatch("pdt/removerResponsavelPt", {
            ptId: props.pt.ptId,
            responsavelId: editingResponsavel.value.responsavelId,
          });

          quasar.notify({
            message: "Responsável atualizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          fecharEdicao();
        } catch (error) {
          if (novoResponsavelId) {
            try {
              await store.dispatch("pdt/removerResponsavelPt", {
                ptId: props.pt.ptId,
                responsavelId: novoResponsavelId,
              });
            } catch (cleanupError) {
              console.error(
                "Erro ao limpar responsável duplicado:",
                cleanupError
              );
            }
          }

          throw error;
        }
      } catch (error) {
        console.error("Erro detalhado:", error);

        let message = "Erro ao atualizar responsável";

        if (error.response?.data?.erro) {
          const erro = error.response.data.erro;
          if (erro.detalhes && Array.isArray(erro.detalhes)) {
            const detalhes = erro.detalhes
              .map((d) => Object.values(d).join(": "))
              .join(", ");
            message = `${erro.mensagem}: ${detalhes}`;
          } else {
            message = erro.mensagem;
          }
        }

        quasar.notify({
          message,
          color: "negative",
        });

        emit("atualizar");
      }
    };

    const editarResponsavel = (responsavel) => {
      editingResponsavel.value = responsavel;
      showEditDialog.value = true;
    };

    const podeEditarResponsavel = (row) => {
      if (row.nome && row.matricula) {
        return false;
      }

      if (props.pt.status === "aberto") {
        return props.usuarioPodeEditar;
      }

      if (props.pt.status === "aguardando_assinaturas") {
        return props.usuarioPodeEditar && props.usuarioPodeAdicionarUser;
      }

      return false;
    };

    const fecharEdicao = () => {
      editingResponsavel.value = null;
      showEditDialog.value = false;
      emit("atualizar");
    };

    const removerResponsavel = async (responsavelId) => {
      try {
        await store.dispatch("pdt/removerResponsavelPt", {
          ptId: props.pt.ptId,
          responsavelId,
        });
        emit("atualizar");
        quasar.notify({
          message: "Responsavel removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Ocorreu um erro ao remover responsavel",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const assinaturaResponsavel = (ptId, responsavelId) => {
      router.push({
        name: "pdt-pt-assinatura",
        params: ({ ptId }, { responsavelId }),
      });
    };

    const podeRemoverResponsavel = (row) => {
      if (row.tipo === "emissor") {
        return false;
      }

      if (props.pt.status === "aberto") {
        return props.usuarioPodeEditar;
      }

      if (props.pt.status === "aguardando_assinaturas") {
        return props.usuarioPodeEditar && props.usuarioPodeRemoverUser;
      }

      if (props.pt.status === "iniciado") {
        return props.usuarioPodeEditar && props.usuarioPodeRemoverUser;
      }

      return false;
    };

    const podeAdicionarResponsavel = computed(() => {
      if (props.pt.status === "aberto") {
        return props.usuarioPodeEditar;
      }

      if (props.pt.status === "aguardando_assinaturas") {
        return props.usuarioPodeEditar && props.usuarioPodeAdicionarUser;
      }

      if (props.pt.status === "iniciado") {
        return props.usuarioPodeEditar && props.usuarioPodeAdicionarUser;
      }

      return false;
    });

    const toggleAssinaturaView = async (responsavel) => {
      if (!responsavel.assinaturas || !responsavel.assinaturas[0]) {
        return;
      }

      const assinatura = responsavel.assinaturas[0];

      // Para assinatura manual, apenas oculta/mostra
      if (assinatura.assinaturaTipo === "manual") {
        responsavel.ocultarAssinatura = !responsavel.ocultarAssinatura;
        return;
      }

      // Para outros tipos, se já está mostrando, apenas oculta
      if (responsavel.mostrandoAssinatura) {
        responsavel.mostrandoAssinatura = false;
        return;
      }

      // Para métodos que precisam processar (biometria, facial)
      if (["biometrica", "facial"].includes(assinatura.assinaturaTipo)) {
        responsavel.carregandoAssinatura = true;
        responsavel.erroAssinatura = false;

        try {
          // Usa o endpoint correto para obter a URL assinada
          const response = await store.dispatch("pdt/getImage", {
            url: assinatura.assinatura,
          });

          // Atualiza a imagem assinada diretamente no objeto
          responsavel.assinaturaImagem = response.data.resultado.dados;
          responsavel.mostrandoAssinatura = true;
        } catch (error) {
          console.log(error);
          responsavel.erroAssinatura = true;

          quasar.notify({
            message: "Erro ao visualizar imagem",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
        } finally {
          responsavel.carregandoAssinatura = false;
        }
      } else {
        responsavel.mostrandoAssinatura = true;
      }
    };

    return {
      columns,
      removerResponsavel,
      url,
      dados,
      assinaturaResponsavel,
      ptId,
      usuario,
      podeRemoverResponsavel,
      podeAdicionarResponsavel,
      toggleAssinaturaView,
      editarResponsavel,
      podeEditarResponsavel,
      fecharEdicao,
      editingResponsavel,
      showEditDialog,
      parceiroSelecionado,
      modalForm,
      dadosTemporarios,
      onTercerizadoChange,
      onFuncionarioSelected,
      onParceiroSelected,
      onTerceiroSelected,
      confirmarEdicao,
    };
  },
};
</script>

<style scoped>
img {
  height: 200px;
  width: 300px;
}
.border-img {
  border: 1px solid #b4b4b4;
  border-radius: 5px;
  height: 185px;
  width: 185px;
}
.cursor {
  cursor: pointer;
}
.texto {
  display: inline;
}
.container {
  position: relative;
}
.teste {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.6;
  text-align: center;
  width: 90%;
}
.teste2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.6;
  font-size: 15px;
  text-align: center;
  width: 90%;
}
.loading-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.loading-text {
  margin-top: 10px;
  font-size: 14px;
  color: #1976d2;
  text-align: center;
}
.mobileGrid {
  display: none;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.texto-assinatura {
  font-size: 13px;
}
@media (max-width: 600px) {
  .container-adiciona {
    margin-left: 10px;
  }
  .mobile {
    display: none !important;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .mobileGrid {
    display: block;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-grid {
    font-size: 12px;
    border-radius: 0px;
  }
  .texto-assinatura {
    font-size: 10px;
  }
  .elipse {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    padding: 0px;
    margin: 2px 5px 0px 0px;
  }
}

.modal-content-wrapper {
  overflow: hidden;
}

.modal-content-wrapper :deep(.q-form) {
  width: 100% !important;
  max-width: 100% !important;
  gap: 8px !important;
}

.modal-content-wrapper :deep(.q-select) {
  max-width: 280px !important;
  width: 280px !important;
  min-width: 250px !important;
}

.modal-content-wrapper :deep(.q-field) {
  max-width: 280px !important;
  width: 280px !important;
  margin-bottom: 0 !important;
}

.modal-content-wrapper :deep(.q-field__control) {
  max-width: 280px !important;
  width: 280px !important;
}

.modal-content-wrapper :deep(.q-field__native) {
  max-width: 260px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.modal-content-wrapper :deep(.col-lg-4),
.modal-content-wrapper :deep(.col-lg-6) {
  max-width: 280px !important;
  flex: 0 0 280px !important;
  margin-right: 8px !important;
  margin-bottom: 8px !important;
}

.modal-content-wrapper :deep(.container-nowrap) {
  flex-wrap: wrap !important;
  gap: 8px !important;
  align-items: flex-start !important;
}

.modal-content-wrapper :deep(.q-btn) {
  white-space: nowrap !important;
  margin-top: 20px !important;
}

.modal-content-wrapper :deep(.q-checkbox) {
  margin-top: 20px !important;
  margin-right: 8px !important;
}

.modal-content-wrapper :deep(.container-input) {
  margin: 0 !important;
  padding: 0 !important;
}

.modal-content-wrapper :deep(.titulo-input) {
  margin-bottom: 4px !important;
  font-size: 12px !important;
}
</style>
